import ReportedIssues from "./ReportedIssues";

export default ReportedIssues;
